import React from 'react';
import { SharingIcons } from './view/sharingIcons';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'SharingIcons', 
  itemElt: (item, cmsOption) => <SharingIcons item={item} cmsOption={cmsOption} />
}